import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { of, switchMap } from 'rxjs';
import { ProfilePhotoService } from '../../services/profile-photo.service';
import { AssigneeAvatarDisplayMode } from './assignee-avatar-display-mode.type';
import { AssigneeAvatarSize } from './assignee-avatar-size.type';

@Component({
  selector: 'app-assignee-avatar',
  templateUrl: './assignee-avatar.component.html',
  styleUrl: './assignee-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, TranslatePipe],
})
export class AssigneeAvatarComponent {
  public readonly decorative = input(false);
  public readonly displayName = input<string | null>(null);
  public readonly displayMode = input<AssigneeAvatarDisplayMode>('avatar');
  public readonly size = input<AssigneeAvatarSize>('medium');
  public readonly userIdentifier = input<string | null>(null);

  private readonly profilePhotoService = inject(ProfilePhotoService);
  protected readonly normalizedName = computed<string | null>(() => this.displayName()?.trim().replace(/\s+/g, ' ') || null);
  protected readonly initials = computed<string>(() => this.getInitials());
  protected readonly photoUrl = toSignal(
    toObservable(this.userIdentifier).pipe(
      switchMap(userIdentifier => (userIdentifier ? this.profilePhotoService.get(userIdentifier) : of(null))),
    ),
    { initialValue: null },
  );

  private getInitials(): string {
    const nameParts =
      this.normalizedName()
        ?.split(/[\s,]+/)
        .filter(Boolean) ?? [];

    if (nameParts.length === 0) {
      return '?';
    }

    return `${nameParts[0][0]}${nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : ''}`.toUpperCase();
  }
}
